import { AuthenticatedApi } from '../utils/Api';

export const RetailService = {
  async getAccounts() {
    await new Promise(resolve => setTimeout(resolve, 4000));
    const { data } = await AuthenticatedApi.get(
      '/api/1.0/retailpos-account/account'
    );
    return data;
  },
  async getShopifyAccount(host) {
    const { data } = await AuthenticatedApi.get(
      '/api/1.0/shopify-stocky-connector/get-integration?host=' + host
    );
    return data;
  },
  async getApiKey() {
    const { data } = await AuthenticatedApi.get(
      '/oauth/shopify-stocky-connector/get-application-client'
    );
    return data;
  },
  async getLocations(host) {
    const { data } = await AuthenticatedApi.get(
      '/api/1.0/shopify-stocky-connector/get-locations?host=' + host
    );
    return data;
  },
  async resyncLocations(shop) {
    const { data } = await AuthenticatedApi.post(
      `/api/1.0/shopify-stocky-connector/resync/location`,
      {
        shop,
      }
    );
    return data;
  },
  async getSuppliers(host) {
    const { data } = await AuthenticatedApi.get(
      '/api/1.0/shopify-stocky-connector/get-suppliers?host=' + host
    );
    return data;
  },
  async resyncSuppliers(shop) {
    const payload = { shop };
    // eslint-disable-next-line no-console
    console.log('[resyncSuppliers] POST /resync/suppliers payload:', payload);
    const { data } = await AuthenticatedApi.post(
      `/api/1.0/shopify-stocky-connector/resync/suppliers`,
      payload
    );
    // eslint-disable-next-line no-console
    console.log('[resyncSuppliers] response:', data);
    return data;
  },
  async getTaxes(host) {
    const { data } = await AuthenticatedApi.get(
      '/api/1.0/shopify-stocky-connector/get-taxes',
      {
        params: {
          host,
        },
      }
    );
    return data;
  },
  async setStockyApiKey(shop, apiKey) {
    const { data } = await AuthenticatedApi.post(
      '/api/1.0/shopify-stocky-connector/add-stocky-api-key',
      {
        shop,
        stockyApiKey: apiKey,
      }
    );
    // eslint-disable-next-line no-console
    if (data?.success === false) return { error: true };
    return data;
  },
  /**
   * Validates a key against GoStock without storing it, so a merchant can be
   * told a key is wrong before anything is committed to their account. Pair with
   * `setGoStockApiKey`, which is what actually switches the shop over.
   */
  async checkGoStockApiKey(shop, goStockApiKey) {
    const { data } = await AuthenticatedApi.post(
      '/api/1.0/shopify-stocky-connector/check-gostock-api-key',
      {
        shop,
        goStockApiKey,
      }
    );
    if (data?.success === false)
      return { error: true, errorMessage: data?.data?.errorMessage };
    return data;
  },
  async setGoStockApiKey(shop, goStockApiKey) {
    const { data } = await AuthenticatedApi.post(
      '/api/1.0/shopify-stocky-connector/add-gostock-api-key',
      {
        shop,
        goStockApiKey,
      }
    );
    if (data?.success === false)
      return { error: true, errorMessage: data?.data?.errorMessage };
    return data;
  },
  async reconnectStocky(host) {
    const payload = { host };
    // eslint-disable-next-line no-console
    console.log('[reconnectStocky] POST /reconnect-stocky payload:', payload);
    const { data } = await AuthenticatedApi.post(
      `/api/1.0/shopify-stocky-connector/reconnect-stocky`,
      payload
    );
    // eslint-disable-next-line no-console
    console.log('[reconnectStocky] response:', data);
    return data;
  },
  async getPaymentTermtemplate(host) {
    const { data } = await AuthenticatedApi.get(
      '/api/1.0/shopify-stocky-connector/get-payment-term-template?host=' + host
    );
    return data;
  },
  async resyncPaymentTerm(shop) {
    const { data } = await AuthenticatedApi.post(
      `/api/1.0/shopify-stocky-connector/resync/payment-term-template`,
      {
        shop,
      }
    );
    return data;
  },
  async enableB2BFeature({ shop, enableB2BFeature }) {
    const { data } = await AuthenticatedApi.post(
      `/api/1.0/shopify-stocky-connector/enable/b2b-feature`,
      {
        shop,
        enableB2BFeature,
      }
    );
    return data;
  },
};
